<template>
  <div class="drawback-kyc">
    <div class="drawback-kyc-content">
      <lls-button
        v-if="'prefill' !== type"
        type="text"
        @click="$router.go(-1)"
        style="padding: 0 20px;color: #89929e;"
      >
        <i class="lls-icon-arrow-left"> {{ $t('common.back') }} </i>
      </lls-button>
      <div class="kyc-title">
        <img src="@/assets/productCenter/kyc-drawback.svg" alt="" />
        <p>{{ $t('exportDrawbackKyc.des' + step) }}</p>
      </div>
      <div class="kyc-form">
        <lls-form
          :model="drawbackFrom"
          :rules="rules"
          ref="drawbackFromRef"
          label-position="top"
          @validate="validate"
        >
          <div class="form-step-container" v-show="step === 1">
            <div class="kyc-subtitle row-full">
              {{ $t('exportDrawbackKyc.enterComInfo') }}
            </div>
            <lls-form-item
              :label="$t('exportDrawbackKyc.companyName')"
              prop="companyName"
            >
              <lls-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="drawbackFrom.companyName"
                maxlength="140"
              ></lls-input>
            </lls-form-item>
            <lls-form-item
              :label="$t('exportDrawbackKyc.usci')"
              prop="companyIdentCode"
            >
              <lls-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="drawbackFrom.companyIdentCode"
                maxlength="18"
                @input="
                  value =>
                    (this.drawbackFrom.companyIdentCode = value.replace(
                      /[^A-Za-z0-9]/g,
                      ''
                    ))
                "
              ></lls-input>
            </lls-form-item>
            <lls-form-item
              :label="$t('exportDrawbackKyc.businessType')"
              prop="productType"
            >
              <lls-radio-group v-model="drawbackFrom.productType">
                <lls-radio label="EXPORT_DRAWBACK_PROD">{{
                  $t('exportDrawbackKyc.manuCompany')
                }}</lls-radio>
                <lls-radio label="EXPORT_DRAWBACK_TRADE">{{
                  $t('exportDrawbackKyc.tradeCompany')
                }}</lls-radio>
              </lls-radio-group>
            </lls-form-item>
            <div class="row-full" style="font-weight: 600;">
              {{ $t('exportDrawbackKyc.uploadBusinessLicense') }}
            </div>
            <KycUpload
              :mediaId="mediaId"
              modelCode="MKJ01ENT"
              catgId="CENT005"
              uploadTipKey="exportDrawbackKyc.businessLicenseTip"
            />
          </div>
          <div class="form-step-container" v-show="step === 2">
            <div class="kyc-subtitle row-full">
              {{ $t('exportDrawbackKyc.enterUserInfo') }}
            </div>
            <lls-form-item
              :label="$t('exportDrawbackKyc.lastName')"
              prop="managerLastName"
            >
              <lls-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="drawbackFrom.managerLastName"
                maxlength="50"
              ></lls-input>
            </lls-form-item>
            <lls-form-item
              :label="$t('exportDrawbackKyc.firstName')"
              prop="mangerFirstName"
            >
              <lls-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="drawbackFrom.mangerFirstName"
                maxlength="50"
              ></lls-input>
            </lls-form-item>
            <lls-form-item
              :label="$t('exportDrawbackKyc.businessEmail')"
              prop="managerEmail"
            >
              <lls-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="drawbackFrom.managerEmail"
                maxlength="200"
              ></lls-input>
            </lls-form-item>
            <lls-form-item
              :label="$t('exportDrawbackKyc.contactNo')"
              prop="managerPhone"
            >
              <lls-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="drawbackFrom.managerPhone"
                maxlength="20"
                @input="
                  value =>
                    (this.drawbackFrom.managerPhone = value.replace(
                      /[^\d]/g,
                      ''
                    ))
                "
              ></lls-input>
            </lls-form-item>
            <lls-form-item
              :label="$t('exportDrawbackKyc.idNo')"
              prop="managerIdentNo"
            >
              <lls-input
                :placeholder="$t('common.inputPlaceholder')"
                v-model="drawbackFrom.managerIdentNo"
                maxlength="20"
              ></lls-input>
            </lls-form-item>
          </div>
          <div class="form-step-container" v-show="step === 3">
            <div class="row-full">
              <span style="font-weight: 600;">{{
                $t('exportDrawbackKyc.des3')
              }}</span>
              <span
                style="color: #3E8CFA;text-decoration: underline;margin-left: 10px;cursor: pointer;"
                @click="handleDownload"
                >{{ $t('exportDrawbackKyc.download') }}</span
              >
            </div>
            <KycUpload
              ref="authLetterRef"
              :mediaId="mediaId"
              modelCode="MKJ03CONTRACT"
              catgId="CCONTRACT001"
              uploadTipKey="exportDrawbackKyc.businessLicenseTip"
            />
            <div>
              <lls-checkbox v-model="agree"></lls-checkbox>
              <span style="margin: 0 4px;">{{
                $t('exportDrawbackKyc.protocolTip')
              }}</span>
              <a
                href="http://www.cfca.com.cn/20150811/101230094.html"
                target="_blank"
                style="color: #3E8CFA;cursor: pointer;"
                >{{ $t("kycFile.openAccountForm.agreement") }}</a
              >
            </div>
          </div>
        </lls-form>
      </div>
    </div>
    <div class="drawback-kyc-footer">
      <lls-button
        v-if="'prefill' === type && step === 1"
        type="primary"
        plain
        @click="handleSkip"
        >{{ $t('exportDrawbackKyc.pass') }}</lls-button
      >
      <lls-button v-if="step !== 1" type="primary" plain @click="handlePrev">{{
        $t('exportDrawbackKyc.prev')
      }}</lls-button>
      <lls-button
        v-if="step !== 3"
        type="primary"
        :disabled="nextDisabled"
        @click="handleNext"
        >{{ $t('exportDrawbackKyc.next') }}</lls-button
      >
      <lls-button
        v-else
        type="primary"
        @click="handleSubmit"
        :loading="loading"
        :disabled="submitDisabled"
        >{{ $t('exportDrawbackKyc.submit') }}</lls-button
      >
    </div>
    <!-- 被授权人与登录用户信息不一致弹窗 -->
    <lls-dialog
      custom-class="check-user-info-dialog"
      title=""
      :visible.sync="checkFailed"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <div class="title">{{ $t('exportDrawbackKyc.updateUserTitle') }}</div>
        <div class="tips">
          {{ $t('exportDrawbackKyc.updateUserTip1') }}
        </div>
        <div class="tips">
          {{ $t('exportDrawbackKyc.updateUserTip2') }}
        </div>
      </div>
      <div slot="footer">
        <lls-button type="primary" @click="handleConfirm">{{
          $t('exportDrawbackKyc.confirm')
        }}</lls-button>
      </div>
    </lls-dialog>
  </div>
</template>
<script>
import KycUpload from '../kycFile/components/kycUpload2'
export default {
  name: 'exportDrawbackKyc',
  components: { KycUpload },
  props: {},
  data() {
    let validatePassEmail = (rule, value, callback) => {
      let regEmail = new RegExp(
        /^[a-zA-Z0-9\.!#\$%&\'\*\+\/=\?_`\{\|\}\~\-\(\)\$\%\\\|\/\,\<\>\^]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      )
      if (value === '') {
        // 请输入邮箱
        callback(new Error(this.$t('login.jsCheck.email')))
      } else if (!regEmail.test(value)) {
        // 邮箱格式错误
        callback(new Error(this.$t('login.jsCheck.emailFormat')))
      } else {
        callback()
      }
    }
    let validateIdNo = (rule, value, callback) => {
      let reg = new RegExp(/^[a-zA-Z0-9]+$/)
      if (!reg.test(value)) {
        // 邮箱格式错误
        callback(new Error(this.$t('exportDrawbackKyc.idNoFormat')))
      } else {
        callback()
      }
    }
    return {
      // prefill 预填写（可跳过）, 如空则为正常kyc
      type: '',
      loading: false,
      checkFailed: false, // 被授权人信息是否和当前登录用户信息一致
      agree: false,
      mediaId: '',
      companyNameCn: '',
      step: 1,
      drawbackFrom: {
        managerLastName: '',
        mangerFirstName: '',
        managerEmail: '',
        managerPhone: '',
        managerIdentNo: '',
        companyName: '',
        companyIdentCode: '',
        productType: '',
        enterpriseId: sessionStorage.getItem('enterpriseId'),
        channelId: '',
      },
      rules: {
        companyName: [
          {
            required: true,
            message:
              this.$t('common.inputPlaceholder') +
              ' ' +
              this.$t('exportDrawbackKyc.companyName'),
            trigger: ['blur', 'change'],
          },
        ],
        companyIdentCode: [
          {
            required: true,
            message:
              this.$t('common.inputPlaceholder') +
              ' ' +
              this.$t('exportDrawbackKyc.usci'),
            trigger: ['blur', 'change'],
          },
        ],
        productType: [
          {
            required: true,
            message:
              this.$t('common.selectPlaceholder') +
              ' ' +
              this.$t('exportDrawbackKyc.businessType'),
            trigger: ['blur', 'change'],
          },
        ],
        mangerFirstName: [
          {
            required: true,
            message:
              this.$t('common.inputPlaceholder') +
              ' ' +
              this.$t('exportDrawbackKyc.firstName'),
            trigger: ['blur', 'change'],
          },
        ],
        managerLastName: [
          {
            required: true,
            message:
              this.$t('common.inputPlaceholder') +
              ' ' +
              this.$t('exportDrawbackKyc.lastName'),
            trigger: ['blur', 'change'],
          },
        ],
        managerEmail: [
          {
            required: true,
            message:
              this.$t('common.inputPlaceholder') +
              ' ' +
              this.$t('exportDrawbackKyc.businessEmail'),
            trigger: ['blur', 'change'],
          },
          { validator: validatePassEmail, trigger: ['change', 'blur'] },
        ],
        managerPhone: [
          {
            required: true,
            message:
              this.$t('common.inputPlaceholder') +
              ' ' +
              this.$t('exportDrawbackKyc.contactNo'),
            trigger: ['blur', 'change'],
          },
        ],
        managerIdentNo: [
          {
            required: true,
            message:
              this.$t('common.inputPlaceholder') +
              ' ' +
              this.$t('exportDrawbackKyc.idNo'),
            trigger: ['blur', 'change'],
          },
          { validator: validateIdNo, trigger: ['change', 'blur'] },
        ],
      },
      emailValid: false,
      idNoValid: false,
      id: '',
    }
  },
  // 计算属性
  computed: {
    submitDisabled() {
      return !this.agree || !this.$refs.authLetterRef?.fileList.length
    },
    nextDisabled() {
      const step1Disabled =
        !this.drawbackFrom.companyName ||
        !this.drawbackFrom.companyIdentCode ||
        !this.drawbackFrom.productType
      const step2Disabled =
        !this.drawbackFrom.managerLastName ||
        !this.drawbackFrom.mangerFirstName ||
        !this.drawbackFrom.managerEmail ||
        !this.drawbackFrom.managerPhone ||
        !this.drawbackFrom.managerIdentNo ||
        !this.emailValid ||
        !this.idNoValid

      return (
        (this.step === 1 && step1Disabled) || (this.step === 2 && step2Disabled)
      )
    },
  },
  // 监听属性
  watch: {},
  // 生命周期 - 创建完成(访问当前this实例)
  created() {
    this.type = this.$route.query.type
    this.getBasicInfo()
    this.getEnterpriseInfo()
  },
  // 生命周期 - 挂载完成(访问DOM元素)
  mounted() {},
  // 方法集合
  methods: {
    validate(prop, res) {
      console.log('data', prop, res)
      if (prop === 'managerEmail') {
        this.emailValid = res
      }
      if (prop === 'managerIdentNo') {
        this.idNoValid = res
      }
    },
    async getBasicInfo() {
      const { getEnterpriseManager } = this.$API.productCenter
      const enterpriseId = sessionStorage.getItem('enterpriseId')
      const { data } = await getEnterpriseManager(enterpriseId)
      if (data.code !== '200') return
      // console.log('getEnterpriseManager', data)
      const { phone, email, remark, id } = data.data
      this.drawbackFrom.managerEmail = email
      this.drawbackFrom.managerPhone = phone
      this.drawbackFrom.channelId = remark
      this.id = id
    },
    // 查询企业信息
    async getEnterpriseInfo() {
      try {
        const enterpriseId = sessionStorage.getItem('enterpriseId')
        const { data } = await this.$API.enterprise.getByEnterpriseId(
          enterpriseId
        )
        if (data.code !== '200') return
        // console.log('getEnterpriseInfo...', data)
        const { companyNameCn, mediaId } = data.data
        // if (this.type === 'prefill') {
        //   // 预填写时回显企业名称
        //   this.drawbackFrom.companyName = companyNameCn
        // }
        this.drawbackFrom.companyName = companyNameCn
        this.companyNameCn = companyNameCn
        this.mediaId = mediaId
      } catch (error) {
        console.log(error)
      }
    },
    handleSkip() {
      // 本次登录已跳过
      sessionStorage.setItem('hasSkip', true)
      this.$router.push({ path: '/main-productCenter' })
    },
    async handleDownload() {
      try {
        this.$API.enterprise.downloadAuthLetter(this.companyNameCn)
      } catch (error) {
        console.log(error)
      }
    },
    async handleNext() {
      if (this.step === 1) {
        // 校验企业信息
        const checked = await this.checkEnterpriseInfo()
        if (!checked) return
      }

      if (this.step === 2) {
        this.checkFailed = !(await this.checkUser())
        if (!this.checkFailed) {
          this.step++
        }
      } else {
        this.step++
      }
    },
    handlePrev() {
      this.step--
    },
    async checkEnterpriseInfo() {
      try {
        const { data } = await this.$API.enterprise.checkInitEnterpriseInfo({
          companyIdentCode: this.drawbackFrom.companyIdentCode,
          companyName: this.drawbackFrom.companyName,
          id: sessionStorage.getItem('enterpriseId'),
        })
        if (data.code !== '200') return false
        return data.data
      } catch (error) {
        console.log(error)
        return false
      }
    },
    async checkUser() {
      try {
        const {
          mangerFirstName: firstName,
          managerLastName: lastName,
          managerEmail: email,
          managerPhone: telephone,
        } = this.drawbackFrom
        const { data } = await this.$API.authorPerson.validateUserAssociation({
          firstName,
          lastName,
          email,
          telephone,
        })
        // console.log('validateUserAssociation', data)
        if (data.code !== '200') return false
        return data.data
      } catch (error) {
        console.log(error)
        return false
      }
    },
    async handleConfirm() {
      const userInfo = JSON.parse(
        sessionStorage.getItem('objCurUserInfo') || '{}'
      )
      // console.log('userInfo', userInfo)
      const {
        mangerFirstName: firstName,
        managerLastName: lastName,
        managerEmail: email,
        managerPhone: telephone,
        managerIdentNo: identNo,
      } = this.drawbackFrom
      const { updateExportManager, editManageUser } = this.$API.authorPerson
      try {
        // 1. 修改业务数据
        const { data } = await updateExportManager({
          id: this.id,
          sysUserId: userInfo.id,
          identType: 'CREDENTIALS_ID',
          identNo,
          firstName,
          lastName,
          email,
          phone: telephone,
        })
        // console.log('updateExportManager', data)
        this.checkFailed = false
        this.step++
        // if (data.code !== '200') return
        // // 2. 修改登录数据
        // const { data: data2 } = await editManageUser({
        //   userId: userInfo.id,
        //   firstName,
        //   lastName,
        //   email,
        //   telephone,
        // })
        // console.log('editManageUser', data2)
        // if (data2.code !== '200') return
        // // 3. 退出登录SSO
        // let res = await this.$sso.logout()
        // if (res.code === '200') {
        //   sessionStorage.clear()
        //   this.$router.replace('/login')
        // }
      } catch (error) {
        console.log(error)
      }
    },
    handleSubmit() {
      const { applyDrawback } = this.$API.productCenter
      this.$refs.drawbackFromRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        const { data } = await applyDrawback(this.drawbackFrom).catch(() => {
          this.loading = false
        })
        this.loading = false
        if (data.code !== '200') return
        this.$router.push('/main-productCenter')
        // 重新获取产品菜单
        this.$parent?.getMenu()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.drawback-kyc {
  height: 100%;
  overflow: auto;
  background-color: #fff;
  &-content {
    height: calc(100% - 64px);
    overflow: auto;
    padding: 32px 0;
  }
  &-footer {
    height: 64px;
    line-height: 64px;
    text-align: center;
    box-shadow: 0 -5px 5px 0 rgba(46, 90, 153, 0.06);
  }
}

.kyc-form {
  width: 760px;
  margin: 0 auto;
  .lls-form {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    .lls-form-item {
      width: 48%;
    }
  }
}

.form-step-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.kyc-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #2e5a99;
  margin-bottom: 32px;
  p {
    margin-top: 20px;
  }
}

.kyc-subtitle {
  font-size: 16px;
  font-weight: 500;
}

.row-full {
  width: 100%;
  margin-bottom: 20px;
}
</style>

<style lang="scss">
.check-user-info-dialog {
  width: 538px !important;
  margin-top: calc((100vh - 200px) / 2) !important;

  .dialog-content {
    .title {
      display: flex;
      justify-content: center;
      font-size: 16px;
      font-weight: 600;
      color: #2e5a99;
    }

    .tips {
      margin-top: 20px;
      font-size: 14px;
      font-weight: 600;
      text-wrap: wrap;
      &:last-child {
        margin-top: 12px;
      }
    }
  }
}
</style>
